// extracted by mini-css-extract-plugin
module.exports = {"card":"Homepage_Card_card__13MGX","img":"Homepage_Card_img__2C6l6","head":"Homepage_Card_head__1jnP3","msg":"Homepage_Card_msg__1M18p"};